export default "__VITE_ASSET__ByJHbKtE__"